<template>
  <v-app>
    <router-view v-if="userStatus"></router-view>
    <Splash v-if="!userStatus"></Splash>
  </v-app>
</template>

<script>
  import firebase from '@/plugins/firebase.js';
  import Splash from '@/views/Splash.vue';

export default {
  name: 'App',
  created: function() {
    firebase.onAuth();
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userStatus() {
      return this.$store.getters.isSignedIn;
    },
    authChecked() {
      return this.$store.getters.authChecked;
    }
  },
  data: () => ({
    //
  }),
  components: {
    Splash
  },
};
</script>

